const CardRoleComponent = () => import('@/views/card/CardRole/CardRoleView')

export default [
    {
        path:'/CardRoleIndex',
        name:'CardRoleRouter',
        component:CardRoleComponent
    }
]